import $ from 'jquery';

$(document).ready(function() {
    const CONTAINER_VISIBLE_CLASS = "search-open";
    const IS_VISIBLE_CLASS = "is-visible"
    const SUB_MENU_EXPANDED_CLASS = "sub-menu-expanded";
    const resultsContainer = $('.c-site-expanded-search');
    const searchInput = $('.c-site-searchbar__input');
    const searchReset = $('.c-site-searchbar__reset');
    const resultsLink = $('#c-site-search-autocomplete-link');

    function searchExpandPadding() { // eslint-disable-line
        if ($(window).width() > 1200) {
            var searchTopPadding = $('.c-site-header').outerHeight();
            $(resultsContainer).css('padding-top', searchTopPadding + 36 + 'px');
        } else {
            $(resultsContainer).css('padding-top', '');
        }
    }

    function handleSearchClose(event) {
        if ($('body').hasClass('search-active')) return;
        if(event.target === searchInput[0]) return;

        if (!$(event.target).closest('#searchInput, .js-toggle-search').length || event.type === 'scroll') {
            $('body').removeClass(CONTAINER_VISIBLE_CLASS);

            const isSearchOpen = $('body').hasClass('search-open');
            const toggleText = isSearchOpen ? $('.js-toggle-search-text').data('open-text') : $('.js-toggle-search-text').data('closed-text');
            $('.js-toggle-search-text').html(toggleText);
        }
    }

    $(document).on('click', handleSearchClose);
    $(window).on('scroll', handleSearchClose);

    $('.js-toggle-search').on('click', () => {
        $('.c-site-nav__item--has-children').removeClass('sub-menu-expanded');
        if ($('body').hasClass('nav-open')) {

            if ($(searchInput).val() === '') {
                $('html').toggleClass('overflow-hidden');
            }
            const menuText = $('.js-toggle-nav-text').data('closed-text');
            $('.js-toggle-nav-text').html(menuText);
        }

        if($('body').hasClass('search-active')) {
            $('html').addClass('overflow-hidden');
        }

        if($('body').hasClass('search-open')) {
            $('html').removeClass('overflow-hidden');
        }

        $('body').removeClass('nav-open').css('padding-top', '');

        if ($('.ais-SearchBox-input').length > 0) {
            $('.ais-SearchBox-input').trigger("focus");
        }else {
            $('body').toggleClass(CONTAINER_VISIBLE_CLASS);
            searchExpandPadding();
            $(searchInput).trigger("focus");

            const toggleText = $('body').hasClass('search-open') ? $('.js-toggle-search-text').data('open-text') : $('.js-toggle-search-text').data('closed-text');
            $('.js-toggle-search-text').html(toggleText);
        }
    });

    $('.c-site-nav__list.is-visible\\@xs .c-site-nav__item--has-children > .c-site-nav__link').on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass(SUB_MENU_EXPANDED_CLASS);
    });

    $(window).on("keydown", function(e) {
        if ($('body').hasClass('search-open')) {
            if (e.key === "Escape") {
                $('body').removeClass(CONTAINER_VISIBLE_CLASS);
                $('html').removeClass('overflow-hidden');

                const toggleText = $('body').hasClass('search-open') ? $('.js-toggle-search-text').data('open-text') : $('.js-toggle-search-text').data('closed-text');
                $('.js-toggle-search-text').html(toggleText);
            } else if (e.key === "Enter" && $(document.activeElement).is(searchInput)) {
                var url = $(resultsLink).attr('href');
                if (url) {
                    window.location.href = url;
                }
            }
        }
    });

    searchInput.on("input", function() {
        const value = $(this).val();
        const hasValue = value.length > 0;
        $('html').toggleClass('overflow-hidden', hasValue);
        $('body').toggleClass('search-active', hasValue);
        resultsContainer.toggleClass(IS_VISIBLE_CLASS, hasValue);
        resultsLink.toggleClass(IS_VISIBLE_CLASS, hasValue).attr("href", `/?s=${value}`);
        searchReset.toggleClass(IS_VISIBLE_CLASS, hasValue);
    });

    searchReset.on('click', function() {
        searchInput.val('');
    });
});


// WEBPACK FOOTER //
// ./scripts/header-search.js